import { Injectable } from "@angular/core";

@Injectable()
export class AppSettingsService {
	settings: any = {};

	get(property: string, defaultReturn?: any) {
		let value = this.settings[property];
		if (value !== null && value !== undefined) {
			return value;
		}
		
		value = this.getFromLocalStorage(property);
		if (value !== null && value !== undefined) {
			return value;
		}

		if (defaultReturn !== null && defaultReturn !== undefined) {
			return defaultReturn;
		}
		
		return undefined;
	}

	getFromLocalStorage(property: string) {
		const value = localStorage.getItem(property);
		if (value !== null && value !== undefined) {
			this.set(property, value);
			return value;
		}
		return undefined;
	}

	reset() {
		this.settings = {};
	}

	resetLocalStorage() {
		localStorage.clear();
	}

	set(property: string, value: any) {
		this.settings[property] = value;
		localStorage.setItem(property, value);
	}
}